import React, { useContext } from 'react';
import CompanyContext from 'company/CompanyContext';

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ fontSize = 70, textAlign = 'center', companyName = '' }) => {
  const {
    company,
  } = useContext(CompanyContext);

  return (
    <div style={{ fontSize: fontSize, textAlign: textAlign, marginTop: '-2px' }}>
      {company.name || companyName}
    </div>);
};
